import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { AstroConnection, AuthContextProvider, ServiceEnvironment } from '@streamelements/client-sdk-js';

export type RouterContext = {
  queryClient: QueryClient;
  serviceEnvironment: ServiceEnvironment;
  authContextProvider: AuthContextProvider;
  sharedAstroConnection: AstroConnection;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
